import React from 'react';
import './Greeting.css';
const Greeting = () => {
  return (
    <div className="content">
      <div className="content__container">
       
        <ul className="content__container__list">
        <li className="content__container__list__item">Comprehensive Expertise</li>
          <li className="content__container__list__item">Rigorous Verification Processes</li>
          <li className="content__container__list__item">Enhanced Testability</li>
          <li className="content__container__list__item">Optimized Physical Design</li>
          <li className="content__container__list__item">High-Performance Analog Solutions</li>
          <li className="content__container__list__item">Efficient RTL Design</li>
          <li className="content__container__list__item">Custom ASIC and Flexible FPGA Designs</li>
          <li className="content__container__list__item">Commitment to Quality</li>
          <li className="content__container__list__item">Customer-Centric Approach</li>
          <li className="content__container__list__item">Innovative Solutions</li>
          <li className="content__container__list__item">Proven Track Record</li>
          <li className="content__container__list__item">Cost-Effective Solutions</li>
        </ul>
      </div>
    </div>
  );
};

export default Greeting;
